<template>
  <hypto-popup :title="'UPI Collections Filter'">
    <template v-slot:body>
      <div class="merge-fields">
        <date-time-range :timeRange="timeRange" @updateDateTime="(newVal) => timeRange = newVal"
                          :reset="resetRange" />

        <md-field :class="{'input-error': $v.upiId.$error}">
          <label>UPI ID</label>
          <md-input v-model="upiId" @blur="$v.upiId.$touch()" />
        </md-field>
        <h6 class="error-message" v-if="$v.upiId.$error">Please enter valid UPI ID</h6>

        <md-field id="Statuses">
          <label>Statuses</label>
          <md-select v-model="statuses" @md-opened="setDropdownPosOffset('Statuses')" multiple>
            <md-option v-for="(status, index) in statusOptions" :key="index" :value="status">
              {{status}}
            </md-option>
          </md-select>
        </md-field>

        <div class="radio-btns">
          <h5>Sort Order</h5>
          <md-radio v-model="sortOrder" :value="'DESC'">Latest</md-radio>
          <md-radio v-model="sortOrder" value="ASC">Oldest</md-radio>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <button class="dark-btn" @click="reset">Reset</button>
      <button class="primary-btn" @click="filter">Apply Filter</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import DateTimeRange from '@/components/global/DateTimePicker'

import { setDropdownPosOffset } from '@/utils/helpers'
import { vpa } from '@/utils/helpers/validators'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'CollectionsFilter',
  components: { HyptoPopup, DateTimeRange },
  data () {
    return {
      timeRange: [null, null],
      upiId: null,
      statusOptions: [
        'COMPLETED',
        'PENDING',
        'FAILED',
        'INVALID_CREDIT',
        'REFUND_PENDING',
        'REFUND_COMPLETED',
        'REFUND_FAILED'
      ],
      statuses: [],
      sortOrder: 'DESC',
      resetRange: false
    }
  },
  validations: {
    upiId: {
      vpa
    }
  },
  computed: {
    ...mapGetters(['getterStatementFilter'])
  },
  created () {
    this.populateData()
  },
  methods: {
    setDropdownPosOffset,
    populateData () {
      const filters = this.getterStatementFilter
      this.sortOrder = filters.sort_order || 'DESC'
      this.upiId = filters.upi_id
      this.statuses = filters.statuses

      if (filters.start_time) {
        this.timeRange = []
        this.timeRange.push(new Date(filters.start_time))
        this.timeRange.push(new Date(filters.end_time))
      }
    },
    getParams () {
      let params = {
        sort_order: this.sortOrder
      }

      if (this.statuses.length) {
        params['statuses'] = this.statuses
      }
      if (this.upiId) {
        params['upi_id'] = this.upiId
      }
      if (!this.timeRange.includes(null)) {
        const dateFormat = 'YYYY-MM-DD HH:mm:ss'
        params['start_time'] = moment(this.timeRange[0]).format(dateFormat)
        params['end_time'] = moment(this.timeRange[1]).format(dateFormat)
      }

      return params
    },
    filter () {
      this.$v.$touch()
      if (!this.$v.$error) {
        const params = this.getParams()
        this.$emit('updateFilters', params)
      }
    },
    reset () {
      this.upiId = null
      this.statuses = []
      this.sortOrder = 'DESC'
      this.resetRange = !this.resetRange
    }
  }
}
</script>
